import styled from "styled-components";

export const InstallmentBox = styled.div`
  flex: 1.4;
  background: #fff;
  border: 1px solid #e9e9e9;
  box-shadow: 0 3px 10px rgba(17, 24, 39, 0.06);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
`;

export const BoxTitle = styled.strong`
  width: 100%;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
`;

export const ParcelText = styled.span`
  width: 100%;
  font-size: 13px;
  line-height: 20px;
  color: #8e8e8e;
  margin-bottom: 16px;
`;

export const OptionCardTop = styled.div`
  display: flex;
  flex-direction: column;
  background: #FFF4F6;
  padding: 12px;
  border-radius: 10px;
  margin-top: 12px;
  justify-content: center;
  align-items: center;
  border: 2px solid #A32D2D;
`;

export const OptionCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  padding: 12px;
  border-radius: 10px;
  margin-top: 12px;
  justify-content: center;
  align-items: center;
`;

export const OptionLabel = styled.span`
  font-size: 12px;
  color: #8e8e8e;
`;

export const OptionValueTop = styled.strong`
  font-size: 14px;
  color: #B94049;
`;

export const OptionValue = styled.strong`
  font-size: 14px;
`;